import React, { Component } from "react";
import Search from "../Search/Search";
import Card from '../Card/Card';
import Paginator from '../Pagination/Paginator'
import '../Home/Home.css';

import {connect} from 'react-redux';
import { getAllTemperaments} from "../../Redux/Actions";
import Error from "../Error/Error";
import Message from "../Message/Message";

import { createPages } from "../../Custom-Methods";


export class Home extends Component {

    componentDidMount(){
        this.props.getAllTemperaments();
    }

    render() {
        const SIZE = 8;
        let total = this.props.dogs?.length || 0;
        let page = this.props.count;
        let pages = {};
        let min = - 1;
        let max = 0;

        if(total > 0){
            pages = createPages(total, SIZE);
            min = pages[page][0];
            max = pages[page][1];
        }

        //* Evaluar mensaje de advertencia
        let objMessage = this.props.message.hasOwnProperty('msg');
        let message = this.props.message.msg;

        //* Evaluar mensaje de error
        let stateError = Object.entries(this.props.error).length > 0;
        let objError = this.props.error;

        return (

            <div>
                <Search />
                <div className='container-slider-home'>
                    
                    {(objMessage) ? <Message content={message} state={objMessage}/>: this.props.dogs?.map(dog => 
                        <Card 
                            key={dog.id} 
                            id={dog.id}
                            image={dog.image}
                            name={dog.name}
                            temperament= {dog.temperament}
                            weight={dog.weight}
                        />
                    ).slice(min, max)
                    }
                    {<Error error={objError} state={(stateError) ? true : false}/>}
                    
                </div>
                <Paginator pageMin={min + 1} pageMax={max} total={total} pages={pages} />
            </div>
        );
    }
}

export const mapStateToProps = function(state){
    return{
        dogs: state.dogs,
        error: state.error,
        count: state.count,
        message: state.message
    }
};

export const mapDispatchToProps = function(dispatch){
return{
    // getAllDogs: (dogs) => dispatch(getAllDogs(dogs)),
    getAllTemperaments: () => dispatch(getAllTemperaments()),
}
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
